import { faro } from '@grafana/faro-web-sdk'

/**
 * Push a caught error into Faro from anywhere in an app.
 *
 * `initFaro` returns the instance, but error boundaries and other deep call
 * sites rarely have it in scope. Faro keeps a module singleton after
 * initialization, so this reads it lazily and no-ops safely when Faro was
 * never initialized (SSR, tests, or an app that hasn't wired it up yet).
 *
 * Errors pushed here land in Loki as `{source="faro", kind="exception"}` with
 * a stable upstream `hash`, which is the fingerprint BugBot keys client
 * signals on.
 */
export function pushError(error: unknown, context?: Record<string, string>): boolean {
  const api = faro?.api
  if (!api?.pushError) {
    return false
  }
  const err = error instanceof Error ? error : new Error(String(error))
  api.pushError(err, context ? { context } : undefined)
  return true
}

/** Whether Faro is initialized in this runtime. */
export function isFaroActive(): boolean {
  return Boolean(faro?.api?.pushError)
}
